/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PotentialChangeOrdersControllerGetProjectStatusCountsQueryResponse, PotentialChangeOrdersControllerGetProjectStatusCountsQueryParams, PotentialChangeOrdersControllerGetProjectStatusCounts401, PotentialChangeOrdersControllerGetProjectStatusCounts403 } from "../../models/changeOrdersController/PotentialChangeOrdersControllerGetProjectStatusCounts";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { potentialChangeOrdersControllerGetProjectStatusCounts } from "../../clients/change-ordersService/potentialChangeOrdersControllerGetProjectStatusCounts";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const potentialChangeOrdersControllerGetProjectStatusCountsQueryKey = (params: PotentialChangeOrdersControllerGetProjectStatusCountsQueryParams) => [{
  url: '/api/v1/project-status-counts'
}, ...(params ? [params] : [])] as const;
export type PotentialChangeOrdersControllerGetProjectStatusCountsQueryKey = ReturnType<typeof potentialChangeOrdersControllerGetProjectStatusCountsQueryKey>;
export function potentialChangeOrdersControllerGetProjectStatusCountsQueryOptions(params: PotentialChangeOrdersControllerGetProjectStatusCountsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = potentialChangeOrdersControllerGetProjectStatusCountsQueryKey(params);
  return queryOptions<PotentialChangeOrdersControllerGetProjectStatusCountsQueryResponse, ResponseErrorConfig<PotentialChangeOrdersControllerGetProjectStatusCounts401 | PotentialChangeOrdersControllerGetProjectStatusCounts403>, PotentialChangeOrdersControllerGetProjectStatusCountsQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return potentialChangeOrdersControllerGetProjectStatusCounts(params, config);
    }
  });
}

/**
 * @summary Get potential change order counts for projects
 * {@link /api/v1/project-status-counts}
 */
export function usePotentialChangeOrdersControllerGetProjectStatusCounts<TData = PotentialChangeOrdersControllerGetProjectStatusCountsQueryResponse, TQueryData = PotentialChangeOrdersControllerGetProjectStatusCountsQueryResponse, TQueryKey extends QueryKey = PotentialChangeOrdersControllerGetProjectStatusCountsQueryKey>(params: PotentialChangeOrdersControllerGetProjectStatusCountsQueryParams, options: {
  query?: Partial<QueryObserverOptions<PotentialChangeOrdersControllerGetProjectStatusCountsQueryResponse, ResponseErrorConfig<PotentialChangeOrdersControllerGetProjectStatusCounts401 | PotentialChangeOrdersControllerGetProjectStatusCounts403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? potentialChangeOrdersControllerGetProjectStatusCountsQueryKey(params);
  const query = useQuery({
    ...potentialChangeOrdersControllerGetProjectStatusCountsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PotentialChangeOrdersControllerGetProjectStatusCounts401 | PotentialChangeOrdersControllerGetProjectStatusCounts403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}